<template>
    <!--<div id="reportBuilderMain" class="card">-->
    <div id="reportBuilderMain">
        <div class="e-card">
            <div class="e-card-header">
                <div class="e-card-header-caption">
                    <div class="e-card-header-title">Report Base info</div>
                </div>
                <br>
            </div>
            <div class="e-card-content">
                <div class="form-row">
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref='dplClients' id="clientName" name="clientName" :enabled="clientEnabled" v-model="data.clientId" :change='onClientChange' floatLabelType='Auto' :dataSource='clients' :fields="{text: 'name', value: 'id' }" placeholder="Clients" :allowFiltering='allowFiltering' :showClearButton='false'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref='dplATG' id="ATG" name="ATG" v-model="data.atgId" :enabled='ATGenabled' :change='onATGChange' :dataSource='tradingGroups' :fields="{text: 'name', value: 'id' }" placeholder="ATG" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='false'></ejs-dropdownlist>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group required-input">
                        <ejs-multiselect ref="mlutility" id='utility' :change="onUtilityChange" :enabled='utilityEnabled' floatLabelType="Auto" name="utility" v-model='data.utilities' :dataSource='utilities' :fields="{text: 'utilityTypeName', value: 'utilityTypeId' }" placeholder="Utility"></ejs-multiselect>
                    </div>
                </div>
                <div v-show="ATGViewEnabled">
                    <div class="form-row">
                        <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group">
                            <ejs-textbox id='country' name="country" floatLabelType="Auto" :disabled="true" v-model="data.country" placeholder="Country"></ejs-textbox>
                        </div>
                    </div>
                </div>
                <div id="reportsClientGrid" class="form-row" v-show="clientEnabled">
                    <div class="form-group col w-auto mt-4 ml-5 d-flex justify-content-center input-group">
                        <div id="mainSpinnerGrid"></div>
                        <ejs-grid ref='clientGrid' :dataSource="contractsData" :allowPaging="true" :allowResizing='true' :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings' :actionComplete='actionComplete' :actionBegin="actionBegin" :actionFailure="actionFailure" :filterSettings='filterOptions'>
                            <e-columns>
                                <e-column field='reportTemplateStateId' headerText='Id' width=120 :visible='false'></e-column>
                                <e-column field='checked' headerText='' :edit='stateCheckboxParams' displayAsCheckBox='true' editType='booleanedit' type='boolean' width=120></e-column>
                                <e-column field='stateName' headerText='Country' :allowEditing="false" width=120></e-column>
                                <e-column field='stateId' headerText='Country' :visible='false' :isPrimaryKey='true' :allowEditing="false" width=120></e-column>
                                <e-column field='companyNames' headerText='Company' width=120></e-column>
                                <e-column field='company' headerText='Company' :visible='false' textAlign='Right' editType='dropdownedit' :edit='companyParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='companies' width=90></e-column>
                                <e-column field='contractNames' headerText='Contract' width=120></e-column>
                                <e-column field='contract' headerText='Contract' :visible='false' textAlign='Right' editType='dropdownedit' :edit='contractParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='contracts' width=90></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
                <div class="form-row">
                    <div v-show="ATGViewEnabled">
                        <div class="form-group col-md-12 ml-5 d-flex justify-content-center input-group">
                            <ejs-grid ref='AtgGrid' :dataSource="atgContractsData" :allowPaging="true" :allowResizing='true' :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings' :actionFailure="actionFailure" :actionComplete="atgActionComplete" :filterSettings='filterOptions'>
                                <e-columns>
                                    <e-column field='reportTemplateStateId' headerText='Id' width=120 :visible='false'></e-column>
                                    <e-column field='checked' headerText='' displayAsCheckBox='true' editType='booleanedit' type='boolean' width=120></e-column>
                                    <e-column field='contract' headerText='Contract Id' :allowEditing="false" width=120></e-column>
                                    <e-column field='contractNames' headerText='Contract Name' :allowEditing="false" width=120></e-column>
                                    <e-column field='companyNames' headerText='Company' :allowEditing="false" width=120></e-column>
                                    <e-column field='client' headerText='Client' :allowEditing="false" width=120></e-column>
                                </e-columns>
                            </ejs-grid>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 ml-5  d-flex justify-content-end input-group">
                        <div v-show="contractAggregatedEnabled">
                            <div class="form-group ml-5  d-flex justify-content-end input-group">
                                <ejs-radiobutton label="Aggregated" name="isAggregatedForContract" value="true" v-model="isAggregatedForContract" :checked="isAggregatedForContract" @click.native="isAggregatedForContractChanged(true)"></ejs-radiobutton>
                                <span class="ml-2 ">   </span>
                                <ejs-radiobutton label="Split" name="isAggregatedForContract" value="false" v-model="isAggregatedForContract" :checked="!isAggregatedForContract" @click.native="isAggregatedForContractChanged(false)"></ejs-radiobutton>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="currencyEnabled">
                    <div class="form-row">
                        <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group">
                            <ejs-dropdownlist id="currency" name="currency" v-model="data.currencyId" :dataSource='currencies' :fields="{text: 'name', value: 'currencyId' }" placeholder="Reporting Currency" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>      
                     
                    </div>
                </div>
                <div v-show="calendarYearsEnabled">
                    <div class="form-row">
                        <div class="form-group col-sm-1 ml-5 d-flex justify-content-start input-group">
                            <ejs-checkbox id="hasCalendarYears" name="hasCalendarYears" :change="onHasCalendarYearsChange" :checked="data.hasCalendarYears" v-model="data.hasCalendarYears" label="Calendar" floatLabelType='Auto'></ejs-checkbox>
                        </div>
                        <div class="form-group col-md-4 d-flex justify-content-start input-group">
                            <ejs-multiselect ref="mlCalendarYears" :index="calendarIndex" id='calendarYears' :change="onCalendarYearsChange" :enabled="hasCalendarYearsEnabled" floatLabelType="Auto" name="calendarYears" v-model='data.calendarYears' :dataSource='calendarYears' :fields="{text: 'name', value: 'id' }" placeholder="Calendar Years"></ejs-multiselect>
                        </div>
                    </div>
                </div>
                <div v-show="fiscalYearsEnabled">
                    <div class="form-row">
                        <div class="form-group col-md-1 ml-5 d-flex justify-content-start input-group">
                            <ejs-checkbox id="hasFiscalYears" name="hasFiscalYears" :change="onHasFiscalYearsChange" :checked="data.hasFiscalYears" v-model="data.hasFiscalYears" label="Fiscal" floatLabelType='Auto'></ejs-checkbox>
                        </div>
                        <div class="form-group col-md-4 d-flex justify-content-start input-group">
                            <ejs-multiselect ref="mlFiscalYears" :index="calendarIndex" :change="onFiscalYearsChange" id='fiscalYears' :enabled="hasFiscalYearsEnabled" floatLabelType="Auto" name="fiscalYears" v-model='data.fiscalYears' :dataSource='fiscalYears' :fields="{text: 'name', value: 'id' }" placeholder="Fiscal Years"></ejs-multiselect>
                        </div>
                    </div>
                </div>
                <div v-show="rollingMonthsEnabled">
                    <div class="form-row">
                        <div class="form-group col-md-1 ml-5 d-flex justify-content-start input-group">
                            <ejs-checkbox id="hasRollingMonths" name="hasRollingMonths" :change="onHasRollingMonthsChange" :checked="data.hasRollingMonths" v-model="data.hasRollingMonths" label="12 Rolling Months" floatLabelType='Auto'></ejs-checkbox>
                        </div>
                        <div class="form-group col-md-4 d-flex justify-content-start input-group">
                            <ejs-dropdownlist id="rollingMonths" name="rollingMonths" v-model="data.rollingMonths" :enabled="hasRollingMonthsEnabled" :dataSource='months' :fields="{text: 'name', value: 'id' }" placeholder="12 Rolling Months" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                    </div>
                </div>
                <div class="card ml-5">
                    <div class="card-header">
                        Customize Report
                    </div>
                    <div class="card-body">
                        <div class="form-row">
                            <div class="form-group col-md-4 d-flex justify-content-start input-group">
                                <ejs-checkbox id="hasTitlePage" name="hasTitlePage" :checked="data.hasTitlePage" :disabled="true" v-model="data.hasTitlePage" label="Title Page" floatLabelType='Auto'></ejs-checkbox>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4 d-flex justify-content-start input-group">
                                <ejs-checkbox id="hasContractView" name="hasContractView" :checked="data.hasContractView" v-model="data.hasContractView" label="Contract Overview" floatLabelType='Auto'></ejs-checkbox>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4 d-flex justify-content-start input-group">
                                <ejs-checkbox id="hasPositionSummary" name="hasPositionSummary" :checked="data.hasPositionSummary" v-model="data.hasPositionSummary" label="Position Summary" floatLabelType='Auto'></ejs-checkbox>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-1 d-flex justify-content-start input-group">
                                <ejs-checkbox id="hasM2MMonth" name="hasM2MMonth" :disabled="true" :checked="true" label="M2M Month" v-model="data.hasM2M" floatLabelType='Auto'></ejs-checkbox>
                            </div>
                        </div>
                        <div v-show="m2mEnabled">
                            <div class="form-row">
                                <div class="form-group col-md-1 d-flex justify-content-start input-group">
                                    <ejs-checkbox ref="hasM2M" id="hasM2M" name="hasM2M" :checked="data.hasM2MPeriod" :change="onHasM2MChange" label="M2M" floatLabelType='Auto'></ejs-checkbox>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-3 d-flex  input-group required-input">
                                    <ejs-multiselect ref="mlperiod" id='period' :enabled="periodEnabled" floatLabelType="Auto" name="period" v-model='data.periods' :dataSource='periods' :fields="{text: 'name', value: 'id' }" placeholder="Period"></ejs-multiselect>
                                </div>
                                <div class="form-group col-md-5 d-flex input-group" style="margin-top:12px">
                                    <div class="mt-3 ml-2 mr-2" >View product as</div>
                                    <ejs-radiobutton label="Combined" cssClass="mt-3" name="isCombined" value="true" v-model="isCombined" :checked="isCombined" @click.native="isCombinedChanged(true)"></ejs-radiobutton>
                                    <span class="ml-2"></span>
                                    <ejs-radiobutton label="Split" cssClass="mt-3" name="isCombined" value="false" v-model="isCombined" :checked="!isCombined" @click.native="isCombinedChanged(false)"></ejs-radiobutton>
                                </div>
                            </div>
                        </div>
                        <div v-show="volumeReportEnabled">
                            <div class="form-row">
                                <div class="form-group col-md-4 d-flex justify-content-start input-group">
                                    <ejs-checkbox id="hasVolumeReport" name="hasVolumeReport" :checked="data.hasVolume" v-model="data.hasVolume" label="Volume Report" floatLabelType='Auto'></ejs-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4 d-flex justify-content-start input-group">
                                <ejs-checkbox id="hasHedgingOverview" name="hasHedgingOverview" :checked="data.hasHedgingOverview" v-model="data.hasHedgingOverview" label="Hedging Overview" floatLabelType='Auto'></ejs-checkbox>
                            </div>
                        </div>
                        <div v-show="pricePerformanceEnabled">
                            <div class="form-row">
                                <div class="form-group col-md-4 d-flex justify-content-start input-group">
                                    <ejs-checkbox id="hasPricePerformance" name="hasPricePerformance" :checked="data.hasPricePerformance" v-model="data.hasPricePerformance" label="Price Performance" floatLabelType='Auto'></ejs-checkbox>
                                </div>
                            </div>
                        </div>
                        <div v-show="costPerformanceEnabled">
                            <div class="form-row">
                                <div class="form-group col-md-4 d-flex justify-content-start input-group">
                                    <ejs-checkbox id="hasCostPerformance" name="hasCostPerformance" :checked="data.hasCostPerformance" v-model="data.hasCostPerformance" label="Cost Performance" floatLabelType='Auto'></ejs-checkbox>
                                </div>
                            </div>
                        </div>
                        <div v-show="ticketReportEnabled">
                            <div class="form-row">
                                <div class="form-group col-md-4 d-flex justify-content-start input-group">
                                    <ejs-checkbox id="hasTicketReport" name="hasTicketReport" :checked="data.hasTicketReport" v-model="data.hasTicketReport" label="Trades Report" floatLabelType='Auto'></ejs-checkbox>
                                </div>
                            </div>
                        </div>
                        <div v-show="hasDefaultMEnabled">
                            <div class="form-row">
                                <div class="form-group col-md-4 d-flex justify-content-start input-group">
                                    <ejs-checkbox id="hasDefaultMechanism" name="hasDefaultMechanism" :checked="data.hasDefaultMechanism" v-model="data.hasDefaultMechanism" label="Default Mechanism" floatLabelType='Auto'></ejs-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group">
                        <ejs-datepicker id="startDate" name="startDate" :min="minDate" :change="onStartDateChange" floatLabelType="Auto" placeholder="Starting on" v-model="data.startDate" :firstDayOfWeek="1" format="dd/MM/yyyy"></ejs-datepicker>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group">
                        <ejs-dropdownlist id="frequency" ref='dplFrequencies' :select="onFrequencySelect" name="frequency" v-model="data.generationFrequency" :dataSource='frequencies' :fields="{text: 'name', value: 'id' }" placeholder="Recurrence" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group required-input">
                        <ejs-textbox id='name' ref="reportName" name="name" floatLabelType="Auto" v-model="data.name" placeholder="Report Name"></ejs-textbox>
                    </div>
                </div>
            </div>
        </div>
        <div class="e-card">
            <div class="e-card-content">
                <div class="clientButtons">
                    <div class="form-row">
                        <div class="form-group col-md-10 justify-content-end ">
                        </div>
                        <ejs-button v-if="canSave" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnSaveClick'>Save</ejs-button>
                        <!--<ejs-button style="margin-right:10px" cssClass="e-warning" v-on:click.native='btnRunClick'>Run Report</ejs-button>-->
                        <ejs-button v-on:click.native='btnBackClick'>Back</ejs-button>

                    </div>
                </div>
            </div>
        </div>
        <div id="saveFormSpinner"></div>
    </div>
    <!--</div>-->
</template>

<script>
    import Vue from "vue";
    import { DropDownListPlugin, MultiSelectPlugin, MultiSelect } from "@syncfusion/ej2-vue-dropdowns";
    import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, CheckBox, ButtonPlugin, RadioButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { NumericTextBoxPlugin, UploaderPlugin, TextBoxPlugin, FormValidator } from "@syncfusion/ej2-vue-inputs";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import SyncHelper from '../../common/syncfusion'
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import apis from '../../common/network'
    import urls from '../../common/urls';
    import store from '../../store';
    import gridOptions from '../../common/gridOptions'
    import { Query } from '@syncfusion/ej2-data';
    import dates from '../../common/dates'
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(RadioButtonPlugin);
    Vue.use(DialogPlugin);
    Vue.use(DatePickerPlugin);
    Vue.use(NumericTextBoxPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(CheckBoxPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(MultiSelectPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    let companyObj, companyElem, contractObj, contractElem, checkboxElem, checkBoxObj;

    export default {
        created() {
            if (!this.$route.params.templateId) return;
            apis.protectedApi(`reportTemplate/${this.$route.params.templateId}`)
                .then(response => {
                    this.data = response.data;
                    if (response.data.atgId != null) {
                        this.atgContractsData = response.data.contracts;
                    }
                    else {
                        this.contractsData = response.data.contracts;
                    }
                    hideSpinner(document.getElementById('mainSpinnerGrid'));
                    this.isAggregatedForContract = response.data.isAggregatedForContract;
                    this.isCombined = response.data.isCombined;
                    this.setupFormFieldsVisibility();

                }).catch(e => {
                    if (e.response) {
                        gridOptions.errorAlert(e.response.data.message);
                        hideSpinner(document.getElementById('mainSpinnerGrid'));
                    }
                })
        },
        mounted() {

            createSpinner({
                target: document.getElementById('saveFormSpinner'),
                width: '100',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingSaveForm'
            });

            createSpinner({
                target: document.getElementById('mainSpinnerGrid'),
                width: '60',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            this.reportBuilderForms = new FormValidator("#reportBuilderMain", this.options);
            if (this.$route.params.templateId) {
                showSpinner(document.getElementById('mainSpinnerGrid'));
            } else {
                this.data.hasTitlePage = true;
                this.data.hasContractView = true;
                this.data.hasPositionSummary = true;
                this.data.isCombined = true;
                if (this.m2mEnabled) {
                    this.data.hasM2M = true;
                    this.data.hasM2MPeriod = true;
                    this.reportBuilderForms.addRules('period', { required: true });
                    this.periodEnabled = true;
                }
                this.data.hasVolume = true
                this.data.hasHedgingOverview = true;
                this.data.hasPricePerformance = true;
                this.data.hasCostPerformance = true;
                this.data.hasTicketReport = true
            }
        },
        data() {
            return {
                data: {},
                canSave: this.$store.state.permissions["Permissions.Reports.Create"],
                companies: SyncHelper.getDataManager("utils/companies"),
                contracts: SyncHelper.getDataManager("utils/contracts"),
                calendarIndex: 0,
                minDate: dates.addDays(new Date(), 1),
                contractsData: [],
                atgContractsData: [],
                reportBuilderForms: null,
                store: store,
                products: null,
                ATGenabled: true,
                ATGViewEnabled: false,
                clientEnabled: true,
                utilityEnabled: false,
                contractAggregatedEnabled: false,
                rollingMonthsEnabled: false,
                hasFiscalYearsEnabled: false,
                hasRollingMonthsEnabled: false,
                fiscalYearsEnabled: false,
                hasCalendarYearsEnabled: false,
                calendarYearsEnabled: false,
                ticketReportEnabled: true,
                hasDefaultMEnabled: true,
                volumeReportEnabled: true,
                costPerformanceEnabled: true,
                pricePerformanceEnabled: true,
                currencyEnabled:true,
                m2mEnabled: true,
                periodEnabled: false,
                isAggregatedForContract: true,
                isCombined: true,
                multiUtility: false,
                multiCompany: false,
                multiCountry: false,
                multiCompanyRows: [],
                countryRows: [],
                pageSettings: gridOptions.pageSettings,
                stateCheckboxParams: {
                    create: function () {
                        checkboxElem = document.createElement('input');
                        return checkboxElem;
                    },
                    read: () => {
                        return checkBoxObj.checked;
                    },
                    destroy: () => {
                        checkBoxObj.destroy();
                    },
                    write: (args) => {
                        checkBoxObj = new CheckBox({
                            cssClass: 'e-primary',
                            checked: args.rowData[args.column.field],
                            disabled: false,
                            change: (args) => {
                                if (checkBoxObj.checked == true) {
                                    companyObj.enabled = true;
                                } else {
                                    companyObj.enabled = false;
                                    companyObj.value = []
                                }
                            }
                        });
                        checkBoxObj.appendTo(checkboxElem);
                    }
                },
                companyParams: {
                    create: () => {
                        companyElem = document.createElement('input');
                        return companyElem;
                    },
                    read: () => {
                        return companyObj.value;
                    },
                    destroy: () => {
                        companyObj.destroy();
                    },
                    write: (args) => {
                        companyObj = new MultiSelect({
                            query: new Query().addParams("stateId", args.rowData.stateId).addParams("clientId", this.$refs.dplClients.ej2Instances.value).addParams("hasAll", true).addParams("companyId", args.rowData.company),
                            dataSource: this.companies,
                            enabled: args.rowData.checked,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: args.rowData.company,
                            floatLabelType: 'Always',
                            cssClass: 'required-input',
                            change: (e) => {
                                if (!e.value)
                                    return;
                                if (e.value.length > 1) {//if by any case we have all and some other items,remove all option
                                    var alreadyInListIndex = e.value.indexOf(0);
                                    if (alreadyInListIndex > -1) {
                                        gridOptions.errorAlert("All and a distinct value is selected,please choose one or the other");
                                        //companyObj.value.splice(alreadyInListIndex, 1);
                                        //companyObj.dataBind()
                                    }

                                }
                                if (companyObj.value.length == 1 && companyObj.value[0] != 0) { //only one is selected and it is not all,so can choose contracts
                                    contractObj.enabled = true;
                                }
                                else if (e.value.length > 0) {// all company is selected so lock to all contracts,or several companies are selected so still give all contracts for those

                                    contractObj.enabled = false;
                                    contractObj.value = [0];// set default value to all as when multiple contracts choosen
                                    contractObj.text = "All";
                                }
                                else {// nothing is chosen for company so remove all contracts for now
                                    contractObj.value = [];
                                }
                                let tempQuery = null;
                                if (this.$refs.mlutility.ej2Instances.value.length == 1) {
                                     tempQuery = new Query().addParams("companyId", companyObj.value).addParams("hasAll", true)
                                         .addParams("utilityId", this.$refs.mlutility.ej2Instances.value[0]);
                                } else {
                                     tempQuery = new Query().addParams("companyId", companyObj.value).addParams("hasAll", true);
                                }                            
                                contractObj.query = tempQuery;
                                contractObj.dataBind();
                            },
                        });
                        companyObj.appendTo(companyElem);
                    }
                },
                contractParams: {
                    create: () => {
                        contractElem = document.createElement('input');
                        return contractElem;
                    },
                    read: () => {
                        return contractObj.value;
                    },
                    destroy: () => {
                        contractObj.destroy();
                    },
                    write: (args) => {
                        contractObj = new MultiSelect({
                            query: document.getElementsByName("utility")[0].length == 1 ? new Query().addParams("companyId", companyObj.value).addParams("hasAll", true).addParams("utilityId", document.getElementsByName("utility")[0].value[0]) : new Query().addParams("companyId", companyObj.value).addParams("hasAll", true),
                            dataSource: this.contracts,
                            enabled: (companyObj.value != null && companyObj.value.length == 1 && companyObj.value[0] != 0),
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: args.rowData.contract,
                            //value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : [0]),
                            placeholder: 'Contracts',
                            floatLabelType: 'Always',
                            change: () => {
                                //if (contractObj.value.length > 1) {//if by any case we have all and some other items,remove all option
                                //    var alreadyInListIndex = contractObj.value.indexOf(0);
                                //    if (alreadyInListIndex > -1) {
                                //      //  contractObj.value.splice(alreadyInListIndex, 1);
                                //    }
                                //}
                            }
                        });
                        contractObj.appendTo(contractElem);
                    }
                },
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: true,//store.state.permissions["Permissions.Reports.Update"],
                    allowAdding: store.state.permissions["Permissions.Reports.Create"],
                    allowDeleting: store.state.permissions["Permissions.Reports.Delete"],
                    mode: 'Normal'
                },
                toolbar: ['Update', 'Cancel'],
                requiredRules: { required: true },
                emailRules: { email: true, required: true },
                nameRules: { required: true, maxLength: 50 },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings,

                options: {
                    //Initialize the CustomPlacement.
                    customPlacement: function (inputElement, errorElement) {
                        inputElement = inputElement.closest('.form-group');
                        errorElement.style.width = '60%'
                        inputElement.appendChild(errorElement);
                    },
                    rules: {
                        'name': {
                            required: true,
                            regex: ['^(?!.*/)^(?!.*%).*$', "% and / are not valid character."]
                        },
                        'utility': {
                            required: true
                        },
                        'ATG': {
                            required: true
                        },
                        'clientName': {
                            required: true
                        },
                        'startDate': {
                            required: false,
                            maxLength: [(args) => { return this.dateEndInPast(args) }, 'Starting date can not be in past.']
                        
                        },
                        'frequency': {
                            required: false
                        },
                        'frequency': {
                            required: false
                        },
                    }
                },
                allowFiltering: true
            }
        },
        methods: {
            dateEndInPast: function (args) {
                if (args.element.defaultValue != args.element.ej2_instances[0].value) {
                    const timeElapsed = Date.now();
                    const today = new Date(timeElapsed);
                    today.toUTCString();
                    if (args.element.ej2_instances[0].changedArgs.isInteracted == true) {
                        return args.element.ej2_instances[0].value > today;
                    } else {
                        return args.element.ej2_instances[0].value;
                    }
                    
                } else {
                    return args.element.ej2_instances[0].value;
                }
            },
           
            isAggregatedForContractChanged: function (value) {
                this.data.isAggregatedForContract = value;
            },
            isCombinedChanged: function (value) {
                this.data.isCombined = value;
            },
            onStartDateChange: function (args) {
                if (args.value) {
                    this.reportBuilderForms.addRules('frequency', { required: true });
                } else {
                    this.reportBuilderForms.addRules('frequency', { required: false });
                }
            },
            onFrequencySelect: function (args) {
                if (args.itemData) {
                    this.reportBuilderForms.addRules('startDate', { required: true });
                }
            },
            setupFormFieldsVisibility: function () {
                //check company level
                var contractData = this.contractsData.filter(function (x) {
                    return x.checked == true;
                });
                contractData.forEach(value => {
                    this.verifyViewSetup(value);
                });
                this.multiUtility = this.data.utilities.length > 1;
                this.onHasCalendarYearsChange({ checked: this.data.hasCalendarYears });
                this.onHasRollingMonthsChange({ checked: this.data.hasRollingMonths });
                this.onHasFiscalYearsChange({ checked: this.data.hasFiscalYears });
                this.onHasM2MChange({ checked: this.data.hasM2MPeriod });
                this.setupVisibility();
            },
            verifyViewSetup: function (value) {
                var alreadyInListIndex = this.multiCompanyRows.indexOf(value.stateId);
                if (value.checked == true && (value.company == null || value.company.length > 1 || value.company.indexOf(0) > -1) && alreadyInListIndex == -1) {//doesnt exist on the list,add and set multi company
                    this.multiCompany = true;
                    this.multiCompanyRows.push(value.stateId);
                }
                else if ((value.checked == false || (value.company != null && value.company.length < 2 && value.company.indexOf(0) == -1)) && alreadyInListIndex > -1) { //exists but now isnt anymore
                    this.multiCompanyRows.splice(alreadyInListIndex, 1);
                    if (this.multiCompanyRows.length < 1) {
                        this.multiCompany = false;
                    }
                }
                // check country level
                var countryAlreadyInListIndex = this.countryRows.indexOf(value.stateId);
                if (value.checked == true && countryAlreadyInListIndex == -1) {//doesnt exist on the list,add and set multi company
                    this.countryRows.push(value.stateId);
                    if (this.countryRows.length > 1) {
                        this.multiCountry = true;
                    }
                }
                else if (value.checked == false && countryAlreadyInListIndex > -1) { //exists but now isnt anymore
                    this.countryRows.splice(countryAlreadyInListIndex, 1);
                    if (this.countryRows.length < 2) {
                        this.multiCountry = false;
                    }
                }
            },
            onUtilityChange: function (e) {
                this.multiUtility = e.value.length > 1;
                this.setupVisibility();
            },
            onClientChange: function (e) {
                showSpinner(document.getElementById('mainSpinnerGrid'));
                this.ATGenabled = false;
                this.contractAggregatedEnabled = false;
                this.multiCompany = false;
                this.multiCompanyRows = [];
                this.multiCountry = false;
                this.countryRows = [];
                this.setupVisibility(); // if on new entry we choose one country,populated some contracts,then switched,refresh base stateand evaluate visible fields
                this.utilityEnabled = true;
                this.ATGViewEnabled = false;
                this.data.atgId = null;
                this.populateContracts(this.$refs.dplClients.ej2Instances.value);
                this.reportBuilderForms.removeRules('ATG', ['required']);
            },
            onATGChange: function (loadInvoked) {
                this.contractAggregatedEnabled = true;
                this.clientEnabled = false;
                this.utilityEnabled = false;
                this.ATGViewEnabled = true;
                this.data.clientId = null;
                this.data.isAggregatedForContract= true;
                this.currencyEnabled = false;
                this.reportBuilderForms.removeRules('clientName', ['required']);
                if (loadInvoked != true) {
                    this.populateAtgContracts(this.$refs.dplATG.ej2Instances.value);
                }
            },
            btnSaveClick: function (e) {
                e.preventDefault();
                let formStatus = this.reportBuilderForms.validate();
                // client level check one of the boxes for years is checked
                if ((this.multiUtility || this.multiCountry || this.multiCompany) && !this.data.hasCalendarYears && !this.data.hasFiscalYears && !this.data.hasRollingMonths) {
                    gridOptions.errorAlert('Please check at least one of the following: fiscal years,calendar years or rolling months!');
                   
                    return;
                }
                if (formStatus) {
                    var reportTemplateId = this.data.id;
                    if (reportTemplateId != undefined) {
                        reportTemplateId = this.data.id;
                    } else {
                        reportTemplateId = 0;
                    }
                    apis.protectedApi.get(`reportTemplate/validateReportName/${this.data.name}/${reportTemplateId}`)
                        .then(response => {
                            if (response.data.isValid) {
                                debugger;
                                if (this.data.id) {
                                    if (this.ATGenabled) {
                                        this.data.contracts = this.$refs.AtgGrid.dataSource;
                                    }
                                    else {
                                        this.data.contracts = this.$refs.clientGrid.dataSource;
                                    }
                                    if (this.data.startDate)
                                        this.data.startDate = this.fixDateOffset(this.data.startDate);

                                    showSpinner(document.getElementById('saveFormSpinner'));
                                    apis.protectedApi.put(`reportTemplate`, this.data)
                                        .then(response => {
                                            let message = { title: 'Success!', content: 'Report builder template is updated successfully', cssClass: 'e-toast-success' };
                                            this.$root.$emit('showToast', message);
                                            this.$router.push({ name: "Report Templates" });
                                            hideSpinner(document.getElementById('saveFormSpinner'));
                                        }).catch(e => {
                                            if (e.response) {
                                                gridOptions.errorAlert(e.response.data.message);
                                                hideSpinner(document.getElementById('saveFormSpinner'));
                                            }
                                        });
                                } else {
                                    if (this.ATGenabled) {
                                        this.data.contracts = this.$refs.AtgGrid.dataSource;
                                    }
                                    else {
                                        this.data.contracts = this.$refs.clientGrid.dataSource;
                                    }
                                    //date offset issues
                                    if (this.data.startDate)
                                        this.data.startDate = this.fixDateOffset(this.data.startDate);

                                    
                                    apis.protectedApi.post(`reportTemplate`, this.data)
                                        .then(response => {
                                            let message = { title: 'Success!', content: 'Report builder template is created successfully', cssClass: 'e-toast-success' };
                                            this.$root.$emit('showToast', message);
                                            this.$router.push({ name: "Report Templates" });
                                            hideSpinner(document.getElementById('saveFormSpinner'));
                                        }).catch(e => {
                                            if (e.response) {
                                                hideSpinner(document.getElementById('saveFormSpinner'));
                                                gridOptions.errorAlert(e.response.data.message);
                                            }
                                        });
                                }
                            } else {
                                hideSpinner(document.getElementById('saveFormSpinner'));
                                gridOptions.errorAlert(`Report template with name ${this.data.name} already exists, please choose another name.`);
                            }
                        }).catch(e => {
                            if (e.response) {
                                hideSpinner(document.getElementById('saveFormSpinner'));
                                gridOptions.errorAlert(e.response.data.message);
                            }
                        });
                }
            },
            btnBackClick: function (e) {
                this.$router.push({ name: "Report Templates" });
            },
            fixDateOffset: function (date) {
                date.setHours(date.getHours() - (date.getTimezoneOffset() / 60));
                return date;
            },
            populateAtgContracts: function (atgId) {
                apis.protectedApi(`ReportTemplate/atgContracts/${atgId}`)
                    .then(response => {
                        this.atgContractsData = response.data.data;
                        this.data.utilities = [response.data.utilityId];
                        this.data.country = response.data.country;
                    }).catch(e => {
                        if (e.response)
                            gridOptions.errorAlert(e.response.data.message);
                    });
            },
            populateContracts: function (clientId) {
                this.$refs.dplClients.ej2Instances.enabled = false;              
                apis.protectedApi(`ReportTemplate/clientContracts/${clientId}`)
                    .then(response => {
                        this.contractsData = response.data.data;
                        hideSpinner(document.getElementById('mainSpinnerGrid'));
                        this.$refs.dplClients.ej2Instances.enabled = true;
                    }).catch(e => {
                        this.$refs.dplClients.ej2Instances.enabled = true;
                        if (e.response)
                            gridOptions.errorAlert(e.response.data.message);
                    });
            },
            onHasCalendarYearsChange: function (e) {
                if (e.checked) {
                    this.hasCalendarYearsEnabled = true;
                    if (this.data.calendarYears == null || this.data.calendarYears.length == 0) {
                        this.data.calendarYears = [0];
                    }
                }
                else {
                    this.hasCalendarYearsEnabled = false;
                    this.data.calendarYears = [];
                }
            },
            onHasFiscalYearsChange: function (e) {
                if (e.checked) {
                    this.hasFiscalYearsEnabled = true;
                    if (this.data.fiscalYears == null || this.data.fiscalYears.length == 0) {
                        this.data.fiscalYears = [0];
                    }
                }
                else {
                    this.hasFiscalYearsEnabled = false;
                    this.data.fiscalYears = [];
                }
            },
            onHasRollingMonthsChange: function (e) {
                if (e.checked) {
                    this.hasRollingMonthsEnabled = true;
                    this.reportBuilderForms.addRules('rollingMonths', { required: true });
                }
                else {
                    this.hasRollingMonthsEnabled = false;
                    this.data.rollingMonths = null;
                    this.reportBuilderForms.removeRules('rollingMonths', ['required']);
                }
            },
            onFiscalYearsChange: function (e) {
                var alreadyInListIndex = e.value.indexOf(0);
                if (alreadyInListIndex > -1 && e.value.length > 1) {
                    gridOptions.errorAlert("All and a distinct value is selected,please choose either All or specific values");
                }
            },
            onCalendarYearsChange: function (e) {
                var alreadyInListIndex = e.value.indexOf(0);
                if (alreadyInListIndex > -1 && e.value.length > 1) {
                    gridOptions.errorAlert("All and a distinct value is selected,please choose either All or specific values");
                }
            },
            onHasM2MChange: function (e) {
                if (e.checked) {
                    this.reportBuilderForms.addRules('period', { required: true });
                    this.periodEnabled = true;
                }
                else {
                    this.reportBuilderForms.addRules('period', { required: false });
                    this.periodEnabled = false;
                    this.data.periods = [];
                }
            },
            atgActionComplete(args) {
                if (args.requestType === 'save') {
                    var contractData = this.atgContractsData.filter(function (x) {
                        return x.contract == args.data.contract;
                    })
                    contractData[0].checked = args.data.checked;
                }
            },
            actionComplete(args) {
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.clientGrid.getColumns().length; i++) {
                        if (this.$refs.clientGrid.getColumns()[i].field == "companyNames") {
                            this.$refs.clientGrid.getColumns()[i].visible = true;
                        } else if (this.$refs.clientGrid.getColumns()[i].field == "company") {
                            this.$refs.clientGrid.getColumns()[i].visible = false;
                        }
                        if (this.$refs.clientGrid.getColumns()[i].field == "contractNames") {
                            this.$refs.clientGrid.getColumns()[i].visible = true;
                        } else if (this.$refs.clientGrid.getColumns()[i].field == "contract") {
                            this.$refs.clientGrid.getColumns()[i].visible = false;
                        }
                    }
                }
                if (args.requestType === 'save') {
                    //check company level
                    var contractData = this.contractsData.filter(function (x) {
                        return x.stateId == args.data.stateId;
                    })
                    let companyNames = [];
                    let contractNames = [];
                    if (companyObj.value) {

                        companyObj.value.forEach(arg => {
                            companyNames.push(companyObj.listData.find(args => args.id == arg).name);
                        })
                    }
                    if (contractObj.value) {
                        contractObj.value.forEach(arg => {
                            contractNames.push(contractObj.listData.find(args => args.id == arg).name);
                        })
                    }
                    contractData[0].companyNames = companyNames.join(', ');
                    contractData[0].contractNames = contractNames.join(', ');
                    contractData[0].company = companyObj.value;
                    contractData[0].contract = contractObj.value;
                    this.verifyViewSetup(args.data);
                    this.setupVisibility();
                    this.$refs.clientGrid.refresh();
                }

            },
            actionBegin(args) {
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.clientGrid.getColumns().length; i++) {
                        if (this.$refs.clientGrid.getColumns()[i].field == "companyNames") {
                            this.$refs.clientGrid.getColumns()[i].visible = false;
                        } else if (this.$refs.clientGrid.getColumns()[i].field == "company") {
                            this.$refs.clientGrid.getColumns()[i].visible = true;
                        }
                        if (this.$refs.clientGrid.getColumns()[i].field == "contractNames") {
                            this.$refs.clientGrid.getColumns()[i].visible = false;
                        } else if (this.$refs.clientGrid.getColumns()[i].field == "contract") {
                            this.$refs.clientGrid.getColumns()[i].visible = true;
                        }
                    }
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            },
            setupVisibility: function () {
                if (this.data.clientId != null) {
                    //only client setup not for atgs,atgs load with default form appeareance
                    if (this.multiUtility || this.multiCountry || this.multiCompany) {
                        this.setCompanyLevelVisibility();
                    }
                    else {
                        this.setContractLevelVisibility();
                    }
                }
                else {
                    this.onATGChange(true);
                }
            },
            setContractLevelVisibility: function () {
                this.reportBuilderForms.removeRules('ATG', ['required']);
                this.reportBuilderForms.removeRules('currency', ['required']);
                if (this.$refs.hasM2M.ej2Instances.checked)
                    this.reportBuilderForms.addRules('period', { required: true });
                this.ATGenabled = false;
                this.ATGViewEnabled = false;
                this.clientEnabled = true;
                this.utilityEnabled = true;
                this.currencyEnabled = false;
                this.rollingMonthsEnabled = false;
                this.data.rollingMonths = null;
                this.fiscalYearsEnabled = false;
                this.data.fiscalYears = [];
                this.data.hasFiscalYears = false;
                this.hasFiscalYearsEnabled = false;
                this.hasRollingMonthsEnabled = false
                this.calendarYearsEnabled = false;
                this.data.calendarYears = [];
                this.data.hasCalendarYears = false;
                this.hasCalendarYearsEnabled = false;
                this.ticketReportEnabled = true;
                this.costPerformanceEnabled = true;
                this.pricePerformanceEnabled = true;
                this.m2mEnabled = true;
                this.periodEnabled = true;
            },
            setCompanyLevelVisibility: function () {
                this.reportBuilderForms.removeRules('ATG', ['required']);
                this.reportBuilderForms.addRules('period', { required: false });
                this.reportBuilderForms.addRules('currency', { required: true });
                this.ATGenabled = false;
                this.ATGViewEnabled = false;
                this.data.atgId = null;
                this.clientEnabled = true;
                this.utilityEnabled = true;
                this.data.view = null;
                this.currencyEnabled = true;
                this.rollingMonthsEnabled = true;
                this.fiscalYearsEnabled = true;
                this.calendarYearsEnabled = true;
                this.volumeReportEnabled = false;
                this.data.hasVolume = false;
                this.ticketReportEnabled = false;
                this.hasDefaultMEnabled = true;
                this.data.hasTicketReport = false;
                this.costPerformanceEnabled = false;
                this.data.hasCostPerformance = false;
                this.pricePerformanceEnabled = false;
                this.data.hasPricePerformance = false;
                this.m2mEnabled = false;
                this.data.hasM2M = false;
                this.data.periods = [];
                this.periodEnabled = false;

            }
        },
        computed: {
            clients() {
                return SyncHelper.getDataManager("utils/parentclientsReport?userId=" + store.state.loggedInUserId);
            },
            tradingGroups() {
                return SyncHelper.getDataManager("utils/tradingGroups");
            },
            utilities() {
                return SyncHelper.getDataManager("utils/utilities");
            },
            frequencies() {
                return SyncHelper.getDataManager("utils/reportFrequencies");
            },
            periods() {
                return SyncHelper.getDataManager("utils/reportPeriods");
            },
            currencies() {
                return SyncHelper.getDataManager("utils/curenciesForReports");
            },
            calendarYears() {
                return SyncHelper.getDataManager("utils/reportCalendarYears");
            },
            fiscalYears() {
                return SyncHelper.getDataManager("utils/reportFiscalYears");
            },
            months: () => {
                return SyncHelper.getDataManager("utils/months");
            }

        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style>
    #reportsClientGrid .e-spinner-pane:not(.loading) {
        display: none !important;
    }


    .loadingSaveForm {
        position: fixed;
        z-index: 1;
        /*height: 100%;
        width: 100%;*/
        background-color: lightgray;
        opacity: 0.6;
        overflow: hidden;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    .required-input .e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
        font-weight: bold;
    }
    .e-radio-wrapper.e-wrapper.mt-3 {
        padding-top: 2px !important;
    }

</style>